/* eslint-disable react/prop-types */
import React from 'react';
import { connect } from 'react-redux';
import { Formik } from 'formik';
import toastr from 'toastr';
import {
  FormGroup,
  Label,
  Input,
  Row,
  Col,
  FormText,
} from 'reactstrap';
import { injectIntl } from 'react-intl';
import styled from 'styled-components';

import Content from '../components/layout/Content';
import FormError from '../components/formControls/FormError';
import SnipperButton from '../components/buttons/SpinnerButton';

import { getUser, updateUser } from '../api/user';
import Loading from '../components/Loading';

class UserDetail extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
    };
  }

  async componentDidMount() {
    const { match: { params } } = this.props;
    const res = await getUser(params.userId);
    this.setState({ user: res.data.user });
  }

  render() {
    const { intl } = this.props;
    const { loading, user } = this.state;
    return (
      <Row>
        <Col>
          {

            <Formik
              initialValues={
                {
                  name: user && user.name,
                  email: user && user.email,
                  password: '',
                  priceChangeable: user && user.priceChangeable,
                  productNameChangeable: user && user.productNameChangeable,
                  categoryNameChangeable: user && user.categoryNameChangeable,
                  designChangeable: user && user.designChangeable,
                }
              }
              enableReinitialize
              onSubmit={async (data) => {
                const { match: { params } } = this.props;
                if (data.password === '') {
                  // eslint-disable-next-line no-param-reassign
                  delete data.password;
                }
                await updateUser(params.userId, data);
                toastr.success('', 'Kullanici basatiyle guncellendi');
              }}
            >
              {({
                values,
                errors,
                handleChange,
                handleBlur,
                handleSubmit,
                /* and other goodies */
              }) => (
                <Content title={intl.formatMessage({ id: 'userDetail.title' })}>
                    {
                      !user ? <Loading />
                        : (
                          <form onSubmit={handleSubmit} encType="multipart/form-data">
                            <FormGroup>
                              <Label for="name">{intl.formatMessage({ id: 'userDetail.name' })}</Label>
                              <Input
                                type="text"
                                name="name"
                                id="name"
                                placeholder={intl.formatMessage({ id: 'userDetail.name' })}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.name}
                              />
                              {errors.name && <FormError error={errors.name} />}
                            </FormGroup>
                            <FormGroup>
                              <Label for="email">{intl.formatMessage({ id: 'userDetail.email' })}</Label>
                              <Input
                                type="email"
                                name="email"
                                id="email"
                                placeholder={intl.formatMessage({ id: 'userDetail.email' })}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.email}
                              />
                              {errors.email && <FormError error={errors.email} />}
                            </FormGroup>
                            <FormGroup>
                              <Label for="password">{intl.formatMessage({ id: 'userDetail.password' })}</Label>
                              <Input
                                type="password"
                                name="password"
                                id="password"
                                placeholder={intl.formatMessage({ id: 'userDetail.password' })}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.password}
                              />
                              <FormText color="muted">
                                If you don&apos;t want change, leave empty.
                              </FormText>
                              {errors.email && <FormError error={errors.email} />}
                            </FormGroup>
                            <PermissonsTitle>{intl.formatMessage({ id: 'userDetail.permissions' })}</PermissonsTitle>
                            <CheckGroup check>
                              <Label check />
                              <Input
                                type="checkbox"
                                name="priceChangeable"
                                id="priceChangeable"
                                onChange={handleChange}
                                onBlur={handleBlur}
                                checked={values.priceChangeable}
                                value={values.priceChangeable}
                              />
                              {intl.formatMessage({ id: 'userDetail.productPrice' })}
                              {errors.email && <FormError error={errors.email} />}
                            </CheckGroup>
                            <CheckGroup check>
                              <Label check />
                              <Input
                                type="checkbox"
                                name="productNameChangeable"
                                id="productNameChangeable"
                                onChange={handleChange}
                                onBlur={handleBlur}
                                checked={values.productNameChangeable}
                                value={values.productNameChangeable}
                              />
                              {intl.formatMessage({ id: 'userDetail.productName' })}
                              {errors.email && <FormError error={errors.email} />}
                            </CheckGroup>
                            <CheckGroup check>
                              <Label check />
                              <Input
                                type="checkbox"
                                name="categoryNameChangeable"
                                id="categoryNameChangeable"
                                onChange={handleChange}
                                onBlur={handleBlur}
                                checked={values.categoryNameChangeable}
                                value={values.categoryNameChangeable}
                              />
                              {intl.formatMessage({ id: 'userDetail.categoryName' })}
                              {errors.email && <FormError error={errors.email} />}
                            </CheckGroup>
                            <CheckGroup check>
                              <Label check />
                              <Input
                                type="checkbox"
                                name="designChangeable"
                                id="designChangeable"
                                onChange={handleChange}
                                onBlur={handleBlur}
                                checked={values.designChangeable}
                                value={values.designChangeable}
                              />
                              {intl.formatMessage({ id: 'userDetail.design' })}
                              {errors.email && <FormError error={errors.email} />}
                            </CheckGroup>
                            <SnipperButton type="submit" loading={loading} text={intl.formatMessage({ id: 'userDetail.editUser' })} />
                          </form>
                        )
                    }

                  </Content>
              )}
            </Formik>
          }
        </Col>
      </Row>
    );
  }
}
const CheckGroup = styled(FormGroup)`
      display: inline-block !important;
      padding: 10px 1.25rem 20px 1.25rem !important;
`;

const PermissonsTitle = styled.h3`
  font-size: 1rem;
`;

export default injectIntl(connect()(UserDetail));
